// extracted by mini-css-extract-plugin
module.exports = {"container":"InputSearch_container__1kfJV"};